// Types
export const CustomerType = {
  INDIVIDUAL: 'individual',
  BUSINESS: 'business',
} as const;

export type CustomerType = (typeof CustomerType)[keyof typeof CustomerType] | null;

export const VULNERABILITIES = [
  'Aboriginal or Torres Strait Islander status',
  'Age',
  'Cultural background',
  'Disability',
  'Family violence',
  'Financial distress',
  'Language barriers',
  'Mental health conditions',
  'Physical health conditions',
  'Remote location',
];

export const LANGUAGES = [
  'Arabic',
  'Cantonese',
  'Greek',
  'Hindi',
  'Italian',
  'Mandarin',
  'Punjabi',
  'Spanish',
  'Vietnamese',
  'Other',
];
